(function () {
  "use strict";

  var CM_PER_INCH = 2.54;

  function init() {
    var root = document.querySelector("[data-fw-pdp]");
    if (!root || root.hasAttribute("data-fw-lowres-ready")) return;
    root.setAttribute("data-fw-lowres-ready", "true");

    var modal = root.querySelector("[data-fw-lowres]");
    if (!modal) return;

    var minDpi = parseFloat(root.getAttribute("data-fw-min-dpi")) || 100;
    var sizes = parsePrintSizes(root.getAttribute("data-fw-print-sizes"));
    if (!sizes.length) return;

    var panel = root.querySelector("[data-fw-upload-panel]");
    var lastKey = ""; // de-dupe repeated events for the same file

    // ---- Wire the modal's own controls --------------------------------
    modal.addEventListener("click", function (e) {
      if (e.target.closest("[data-fw-lowres-close]")) {
        e.preventDefault();
        closeModal(modal);
      } else if (e.target.closest("[data-fw-lowres-retry]")) {
        e.preventDefault();
        closeModal(modal);
        triggerReupload(root);
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !modal.hidden) closeModal(modal);
    });

    // ---- 1a. File input change — capture phase catches FilePond's input ----
    document.addEventListener(
      "change",
      function (e) {
        var input = e.target;
        if (!input || input.type !== "file" || !input.files || !input.files.length) return;
        if (!root.contains(input)) return;
        handleFile(input.files[0]);
      },
      true
    );

    // ---- 1b. FilePond custom events (fired on the pond root element) --------
    // FilePond dispatches "FilePond:addfile" on the .filepond--root div with
    // detail.file.origin (1=INPUT, 3=LIMBO) and detail.file.file (native File).
    document.addEventListener("FilePond:addfile", function (e) {
      if (!e.detail || !e.detail.file) return;
      var nativeFile = e.detail.file.file || (e.detail.file.source instanceof File ? e.detail.file.source : null);
      if (!nativeFile) return;
      // Guard: only act if the FilePond instance is inside our shell.
      var pondEl = e.target && e.target.closest ? e.target.closest(".filepond--root") : null;
      if (pondEl && !root.contains(pondEl)) return;
      handleFile(nativeFile);
    });

    // ---- 2. Drag & drop onto the panel --------------------------------
    if (panel) {
      ["dragenter", "dragover"].forEach(function (evt) {
        panel.addEventListener(evt, function (e) {
          e.preventDefault();
          panel.classList.add("is-dragover");
        });
      });
      ["dragleave", "dragend", "drop"].forEach(function (evt) {
        panel.addEventListener(evt, function () {
          panel.classList.remove("is-dragover");
        });
      });
      panel.addEventListener("drop", function (e) {
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
          handleFile(e.dataTransfer.files[0]);
        }
      });
    }

    // ---- 3. Fallback: watch for a preview <img> appearing -------------
    if (panel) {
      var obs = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          Array.prototype.forEach.call(m.addedNodes, function (node) {
            if (node.nodeType !== 1) return;
            var img = node.tagName === "IMG" ? node : node.querySelector && node.querySelector("img");
            if (!img) return;
            var src = img.getAttribute("src") || "";
            if (src.indexOf("blob:") !== 0 && src.indexOf("data:") !== 0) return;
            measureImageEl(img, function (w, h) {
              evaluate(w, h, "preview:" + src);
            });
          });
        });
      });
      obs.observe(panel, { childList: true, subtree: true });
    }

    // ---- 4. FilePond native API hook (most reliable) --------------------
    // window.FilePond (global from FilePond UMD/ESM build) exposes
    // FilePond.find(el) → pond instance with .on('addfile', cb).
    // This fires even in versions where the custom DOM event is unreliable.
    // UploadLift may init FilePond asynchronously, so we retry briefly.
    (function tryHookFilePondApi() {
      function attempt() {
        if (!window.FilePond || typeof window.FilePond.find !== "function") return false;
        var pondEl = (panel || root).querySelector(".filepond--root");
        if (!pondEl) return false;
        try {
          var instance = window.FilePond.find(pondEl);
          if (!instance || typeof instance.on !== "function") return false;
          instance.on("addfile", function (error, fileItem) {
            if (error) return;
            var nativeFile = fileItem && fileItem.file;
            if (nativeFile) handleFile(nativeFile);
          });
          return true;
        } catch (err) {
          return false;
        }
      }
      if (!attempt()) {
        var tries = 0;
        var iv = setInterval(function () {
          tries++;
          if (attempt() || tries >= 15) clearInterval(iv);
        }, 300); // 15 tries × 300 ms = 4.5 s window
      }
    })();

    // ---- Core helpers -------------------------------------------------
    function handleFile(file) {
      if (!file || !/^image\//i.test(file.type)) return;
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        evaluate(img.naturalWidth, img.naturalHeight, "file:" + file.name + ":" + file.size);
        URL.revokeObjectURL(url);
      };
      img.onerror = function () {
        // Undecodable (e.g. HEIC) — we cannot judge, so stay silent.
        URL.revokeObjectURL(url);
      };
      img.src = url;
    }

    function evaluate(pxW, pxH, key) {
      if (!pxW || !pxH) return;
      if (key && key === lastKey) return; // already handled this exact file
      lastKey = key || "";

      var available = [];
      var tooSmall = [];
      sizes.forEach(function (s) {
        var dpi = effectiveDpi(pxW, pxH, s.w, s.h);
        if (dpi >= minDpi) {
          available.push(s.name);
        } else {
          tooSmall.push(s.name);
        }
      });

      // All sizes fine → nothing to say.
      if (!tooSmall.length) return;

      populateAndOpen(available, tooSmall);
    }

    function populateAndOpen(available, tooSmall) {
      var body = modal.querySelector("[data-fw-lowres-body]");
      var sizesEl = modal.querySelector("[data-fw-lowres-sizes]");

      if (!available.length) {
        // Too small for even the smallest frame.
        if (body) {
          body.innerHTML =
            "This one is a touch too small to print sharply in any of our sizes. " +
            "If it was sent to you on WhatsApp or by email, ask whoever took it for the original from their camera roll. It will do your photo justice.";
        }
        if (sizesEl) {
          sizesEl.hidden = false;
          sizesEl.textContent = "We can't print this file sharply enough, but the original will be perfect.";
        }
      } else {
        if (body) {
          body.innerHTML =
            "This one is a touch too small for the larger sizes. " +
            "If it was sent to you on WhatsApp or by email, ask whoever took it for the original from their camera roll.";
        }
        if (sizesEl) {
          sizesEl.hidden = false;
          sizesEl.innerHTML =
            "<strong>It will still look lovely in:</strong> " +
            available.join(", ") +
            ".<br>For the original only: " +
            tooSmall.join(", ") +
            ".";
        }
      }

      openModal(modal);
    }
  }

  // --------------------------------------------------------------------------
  // Best-fit DPI across both orientations (portrait/landscape) for a print
  // area of cmW x cmH. Returns the DPI the photo would achieve at that size.
  function effectiveDpi(pxW, pxH, cmW, cmH) {
    var inW = cmW / CM_PER_INCH;
    var inH = cmH / CM_PER_INCH;
    var fitA = Math.min(pxW / inW, pxH / inH); // image orientation = print orientation
    var fitB = Math.min(pxW / inH, pxH / inW); // rotated 90°
    return Math.max(fitA, fitB);
  }

  function measureImageEl(img, cb) {
    if (img.complete && img.naturalWidth) {
      cb(img.naturalWidth, img.naturalHeight);
    } else {
      img.addEventListener("load", function () {
        cb(img.naturalWidth, img.naturalHeight);
      });
    }
  }

  function parsePrintSizes(attr) {
    if (!attr) return [];
    try {
      var arr = JSON.parse(attr);
      return Array.isArray(arr) ? arr.filter(function (s) { return s && s.w && s.h && s.name; }) : [];
    } catch (e) {
      return [];
    }
  }

  function openModal(modal) {
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("fw-lowres-open");
    var dialog = modal.querySelector(".fw-lowres__dialog");
    if (dialog && typeof dialog.focus === "function") dialog.focus();
  }

  function closeModal(modal) {
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("fw-lowres-open");
  }

  // Best-effort: re-open the device file picker so the user can choose again.
  function triggerReupload(root) {
    var input = root.querySelector('input[type="file"]');
    if (input) {
      try { input.click(); return; } catch (e) {}
    }
    // Fall back to clicking the widget's own browse control.
    var browse = root.querySelector(
      '[data-fw-slot="upload"] button, [data-fw-slot="upload"] [role="button"], [data-fw-slot="upload"] label'
    );
    if (browse) {
      try { browse.click(); } catch (e) {}
    }
  }

  // --------------------------------------------------------------------------
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
